var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCourierInstructionsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_52609",
    "data-name": "Group 52609",
    transform: "translate(-712 -3170.968)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_18649",
    "data-name": "Rectangle 18649",
    transform: "translate(712 3170.968)",
    fill: "none",
    stroke: "#93a750",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    rx: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 83,
    height: 83,
    rx: 19.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Instructions_",
    "data-name": "Instructions ",
    transform: "translate(740 3208.009)",
    fill: "#93a750",
    fontSize: 6,
    fontFamily: "Impact",
    letterSpacing: "0.035em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Instructions ")), /*#__PURE__*/React.createElement("text", {
    id: "Courier_",
    "data-name": "Courier ",
    transform: "translate(733 3201.009)",
    fill: "#93a750",
    fontSize: 6,
    fontFamily: "Impact",
    letterSpacing: "0.035em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Courier ")), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_17_",
    "data-name": "svgexport-7 (17)",
    transform: "translate(691.066 3176.831)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x32_6_Manual",
    transform: "translate(33.52 2.641)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52544",
    "data-name": "Group 52544"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91034",
    "data-name": "Path 91034",
    d: "M110.676,302.459h34.959a.8.8,0,1,0,0-1.6H110.676a.8.8,0,0,0,0,1.6Z",
    transform: "translate(-99.782 -261.433)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91035",
    "data-name": "Path 91035",
    d: "M110.676,259.148h34.959a.8.8,0,1,0,0-1.6H110.676a.8.8,0,0,0,0,1.6Z",
    transform: "translate(-99.782 -223.848)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91036",
    "data-name": "Path 91036",
    d: "M110.676,345.763h34.959a.8.8,0,1,0,0-1.6H110.676a.8.8,0,1,0,0,1.6Z",
    transform: "translate(-99.782 -299.012)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91037",
    "data-name": "Path 91037",
    d: "M129.681,387.476h-19a.8.8,0,0,0,0,1.6h19a.8.8,0,1,0,0-1.6Z",
    transform: "translate(-99.782 -336.598)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91038",
    "data-name": "Path 91038",
    d: "M85.046,51.961V21.039c0-.011-.011-.021-.011-.032a.61.61,0,0,0-.043-.235c-.011-.021-.011-.043-.021-.064a1.023,1.023,0,0,0-.149-.224.01.01,0,0,1-.011-.011L82.19,17.851l-2.366-2.366V6.4A3.771,3.771,0,0,0,76.05,2.641H37.283A3.762,3.762,0,0,0,33.52,6.4V61.362a3.771,3.771,0,0,0,3.763,3.773h1.46V66.3a3.334,3.334,0,0,0,3.336,3.336H81.71a2.884,2.884,0,0,0,.6-.085,7.647,7.647,0,0,0,1.109.075,8.9,8.9,0,0,0,1.631-17.662ZM71.935,9.868l8.986,8.975,1.4,1.4H73.673A1.745,1.745,0,0,1,71.935,18.5ZM42.079,68.035A1.738,1.738,0,0,1,40.342,66.3V10.475a1.738,1.738,0,0,1,1.737-1.737H70.337V18.5a3.341,3.341,0,0,0,3.336,3.336h9.774V51.8h-.032a8.909,8.909,0,0,0-5.084,16.234Zm45.39-8.482L82.622,64.4a.8.8,0,0,1-1.13,0L79.37,62.28A.8.8,0,1,1,80.5,61.149l1.556,1.556,4.282-4.283a.8.8,0,1,1,1.13,1.131Z",
    transform: "translate(-33.52 -2.641)",
    fill: "#93a750"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourierInstructionsIcon);
export default __webpack_public_path__ + "static/media/CourierInstructionsIcon.567cedbbcd1dd8051cbbcd533220df10.svg";
export { ForwardRef as ReactComponent };